/*
* 検索（エリアマップ）用
*/
$(function() {

  //エリアのチェックボックスの動き
  $(document).on('change', '.parent-checkbox', function(e) {
    $(this).closest('li').find('.child-checkbox').prop('checked', this.checked);
    const areaId = $(this).val();
    toggleAreaClass(areaId);
  });

  // 子チェックボックスの変更を監視
  $(document).on('change', '.child-checkbox', function() {
    const $parentLi = $(this).closest('li').parent().closest('li');
    const $parentCheckbox = $parentLi.find('.parent-checkbox');
    const $parentAreaId = $parentCheckbox.attr('value');
    const areaId = $(this).val();

    if($(this).is(':checked')) {
      // 全ての子チェックボックスがチェックされているか確認
      const allChecked = $parentLi.find('.child-checkbox').length === $parentLi.find('.child-checkbox:checked').length;
      $parentCheckbox.prop('checked', allChecked);
    } else {
      // いずれかの子が外れたら、親も外す
      $parentCheckbox.prop('checked', false);
    }
    toggleAreaClass($parentAreaId);
  });
  

  //エリアのマップをクリックしたときの動き
  $(document).on('click', '.area_map', function(e) {

    e.preventDefault();
    // クリックされた要素の data-area-id 属性を取得
    const areaId = $(this).data('areaId');
    //エリア名の色と、チェックボックスの処理
    toggleAreaClass(areaId);
    togglCheckbox(areaId);
  });

  //エリア名をクリックしたときの動き
  $(document).on('click', '.area-item', function(e) {

    e.preventDefault();
    // クリックされた要素の data-area-id 属性を取得
    const areaId = $(this).data('areaId');
    //マップの色と、チェックボックスの処理
    toggleAreaClass(areaId, '.area_map');
    togglCheckbox(areaId);
  });
});

function toggleAreaClass(areaId) {
  selectors = ['.area_map', '.area-item'];
  // 各セレクタに対する処理
  selectors.forEach(function(selector) {
    // 同じ area-id を持つ要素を検索
    const itemElement = $(selector).filter(function() {
      return $(this).attr('data-area-id') === areaId.toString();
    });

    const classes = itemElement.attr('class');
    if (classes.includes('active')) {
      // active クラスが存在する場合は削除
      itemElement.attr('class', classes.replace('active', '').trim());
    } else {
      // active クラスが存在しない場合は追加
      itemElement.attr('class', classes + ' active');
    }
  });
}

function togglCheckbox(areaId) {
  // 同じ value を持つ parent-checkbox を検索
  const parentCheckbox = $('.parent-checkbox').filter(function() {
    return $(this).val() === areaId.toString();
  });

  // 現在のチェック状態を取得し、反転させる
  const isChecked = parentCheckbox.prop('checked');
  parentCheckbox.prop('checked', !isChecked).closest('li').find('.child-checkbox').prop('checked', !isChecked); 
}